import { initExploreOnScroll } from "../../helpers/helpers.js";

export default class TableDownloader {
  constructor() {
    this.btn = $('.js-download-table-button');    
  }

  init() {
    this.btn.on('click', (ev) => {
      const table = $(ev.currentTarget).closest('.js-download-table');
      const blockid = table.attr('data-blockid');
      const rowuidselected = [];
      //console.log(table, blockid);

      $('.js-download-table-row', table).each((idx, row) => {
        if ($('.js-download-table-row-checkbox', row).prop('checked')) {
          rowuidselected.push($(row).attr('data-downloadtablerowid'));
        }
      });

      if (rowuidselected.length > 0) {
        var form = $('<form/>', {
          action: '/' + TheApp.Locale + '/action/download',
          method: 'POST'
        });
        form.append($('<input/>', {
          type: 'hidden',
          name: 'blockid',
          value: blockid
        }));
        form.append($('<input/>', {
          type: 'hidden',
          name: 'rowuidselected',
          value: rowuidselected.join(',')
        }));
        form.appendTo('body').submit();
      }
    });

    const tables = document.querySelectorAll(".js-download-table");
    tables?.forEach(table => this.initTable(table));
  }

  initTable(table) {
    const inputAll = table.querySelector(".table-row-head input[type='checkbox']");
    const inputs = table.querySelectorAll(".table-row:not(.table-row-head) input[type='checkbox']");
    const btns = table.querySelectorAll(".js-btn-toggle-row-mob");

    inputAll?.addEventListener("change", (e) => {
      inputAll.checked
        ? inputs?.forEach(input => input.checked = true)
        : inputs?.forEach(input => input.checked = false);

      inputs?.forEach(input => {
        input.checked = inputAll.checked ? true : false;
        input.dispatchEvent(new Event("change"));
      });
    });

    inputs?.forEach(input => {
      input.addEventListener("change", (e) => {
        input.checked
          ? input.closest(".js-download-table-row")?.classList.add("is-selected")
          : input.closest(".js-download-table-row")?.classList.remove("is-selected");

        // show download btn banner
        Array.from(inputs).some(input => input.checked)
          ? this.btn.closest(".js-download-selection")?.addClass("is-visible")
          : this.btn.closest(".js-download-selection")?.removeClass("is-visible");
      });
    });    

    btns?.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        const sibling = Array.from(btns)?.find(b => b !== btn && b.classList.contains("is-active"));
        sibling?.classList.remove("is-active");
        sibling?.closest(".js-download-table-row")?.classList.remove("has-bg-dark");

        btn.classList.toggle("is-active");
        btn.closest(".js-download-table-row")?.classList.toggle("has-bg-dark");
      });
    });
  }
}